export default [
  {
    id: 'N/A',
    name: 'Select your company',
  },
  {
    id: 'alaska',
    name: 'Alaska Airlines Mileage Plan™',
  },
  {
    id: 'alliant',
    name: 'Alliant Credit Union',
  },
  {
    id: 'ally',
    name: 'Ally Bank',
  },
  {
    id: 'amex',
    name: 'American Express',
  },
  {
    id: 'ascent',
    name: 'Ascent',
  },
  {
    id: 'capitalone',
    name: 'Capital One',
  },
  {
    id: 'chase',
    name: 'Chase',
  },
  {
    id: 'collegeave',
    name: 'College Ave',
  },
  {
    id: 'commonbond',
    name: 'CommonBond',
  },
  {
    id: 'delta',
    name: 'Delta SkyMiles',
  },
  {
    id: 'discover',
    name: 'Discover',
  },
  {
    id: 'earnest',
    name: 'Earnest',
  },
  {
    id: 'fidelity',
    name: 'Fidelity Investments',
  },
  {
    id: 'flagstar',
    name: 'Flagstar Bank',
  },
  {
    id: 'geico',
    name: 'GEICO',
  },
  {
    id: 'gemini',
    name: 'Gemini',
  },
  {
    id: 'havenlife',
    name: 'Haven Life',
  },
  {
    id: 'isl',
    name: 'ISL',
  },
  {
    id: 'lakemichigan',
    name: 'Lake Michigan Credit Union',
  },
  {
    id: 'lenderfi',
    name: 'LenderFi',
  },
  {
    id: 'lightstream',
    name: 'LightStream',
  },
  {
    id: 'marcus',
    name: 'Marcus by Goldman Sachs',
  },
  {
    id: 'nasb',
    name: 'North American Savings Bank',
  },
  {
    id: 'pennymac',
    name: 'PennyMac',
  },
  {
    id: 'radisson',
    name: 'Radisson',
  },
  {
    id: 'schwab',
    name: 'Schwab Bank',
  },
  {
    id: 'sofi',
    name: 'SoFi',
  },
  {
    id: 'tdameritrade',
    name: 'TD Ameritrade',
  },
  {
    id: 'tradestation',
    name: 'TradeStation',
  },
  {
    id: 'upgrade',
    name: 'Upgrade',
  },
  {
    id: 'upstart',
    name: 'Upstart',
  },
  {
    id: 'usbank',
    name: 'U.S. Bank',
  },
  {
    id: 'vanguarddigital',
    name: 'Vanguard Digital Advisor',
  },
  {
    id: 'wealthfront',
    name: 'Wealthfront',
  },
  {
    id: 'wellsfargo',
    name: 'Wells Fargo',
  },
  {
    id: 'worldofhyatt',
    name: 'World of Hyatt',
  },
  {
    id: 'zoefinancial',
    name: 'Zoe Financial',
  },
  {
    id: 'zynlobank',
    name: 'Zynlo Bank',
  },
];
